export const PLAN_OPTIONS = [
  "id",
  "tableIndex",
  "nameLine",
  "fio",
  "fixExplanation",
  "planToFixAt",
  "responsiblePersonContact",
  "fixedAt",
  "Files",
  "reason",
  "isResolved",
];

export const PLAN_REPORT_SELECT_INDICATORS_PERIOD_OPTIONS = [
  "services",
  "places",
  "placePosts",
  "warehouses",
  "tools",
  "requiredTools",
  "personal",
  "toolsInsurance",
  "toolsMetrological",
  "notes",
  "tradePremises",
];
